module.exports = __webpack_public_path__ + "img/eye.39e94ba.svg";